// @flow
import React from 'react';
import { connect } from 'react-redux';
import { logout } from '@context/user';
import { mapBundledPermission, mapPlanIncludes } from '@helpers/connect';
import { get } from 'lodash';
import { DocumentsTemplatesList as DocumentsTemplatesListView } from '../components/views';
import { documentsTemplateActions } from '../redux/modules/context/documentsTemplates';
import type { Dispatch, DocumentsTemplatesState, User, BundledPermissions, PlanInclude } from '../types';


type Props = {
  documentsTemplates: DocumentsTemplatesState,
  user: User,
  dispatch: Function,
  permissions: BundledPermissions,
  planInclude: PlanInclude,
};

class DocumentsTemplatesList extends React.Component<Props> {
  componentWillMount() {
    this.props.dispatch(documentsTemplateActions.getDocumentsTemplates(true));
  }

  render() {
    const { user, planInclude } = this.props;

    return (
      <DocumentsTemplatesListView
        documentsTemplates={this.props.documentsTemplates}
        user={user}
        onLogout={this.handleLogout}
        permissions={this.props.permissions}
        featureEnabled={planInclude.examsDrugsDocuments}
      />
    );
  }
  handleLogout = () => this.props.dispatch(logout());
}

const mapStateToProps = (state) => ({
  documentsTemplates: get(state.context, ['documentsTemplates'], {}),
  user: state.context.user,
  permissions: mapBundledPermission(state),
  planInclude: mapPlanIncludes(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({ dispatch });

export default connect<any, any, any, any, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentsTemplatesList);
